import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import pino from 'pino';
import { tracingCookie, getDefaultSessionTracing, getClientDefaultSessionTracing } from '../utils/tracing';
var getLogger = () => {
  var logger = pino({
    level: process.env.NEXT_PUBLIC_LOG_LEVEL || 'info'
  });
  return logger;
};
var defaultLogger = getLogger();
var instrument = (_ref, fn) => {
  var label = _ref.label,
    msg = _objectWithoutProperties(_ref, _excluded);
  return _asyncToGenerator(function* () {
    defaultLogger.info({
      label: "".concat(label, "_START"),
      msg
    });
    var resp = yield fn(...arguments);
    defaultLogger.info({
      label: "".concat(label, "_END"),
      msg
    });
    return resp;
  });
};
var instrumentQueryClient = function instrumentQueryClient(queryClient) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function prefetchQuery() {
    var fn = instrument(_objectSpread({
      label: 'PREFETCH_QUERY',
      queryKey: arguments.length <= 0 ? undefined : arguments[0]
    }, msg), queryClient.prefetchQuery.bind(queryClient));
    return fn({
      queryKey: arguments.length <= 0 ? undefined : arguments[0],
      queryFn: arguments.length <= 1 ? undefined : arguments[1]
    });
  }
  function fetchQuery() {
    var fn = instrument(_objectSpread({
      label: 'FETCH_QUERY',
      queryKey: arguments.length <= 0 ? undefined : arguments[0]
    }, msg), queryClient.fetchQuery.bind(queryClient));
    return fn({
      queryKey: arguments.length <= 0 ? undefined : arguments[0],
      queryFn: arguments.length <= 1 ? undefined : arguments[1]
    });
  }
  return {
    prefetchQuery: prefetchQuery.bind(queryClient),
    fetchQuery: fetchQuery.bind(queryClient)
  };
};
export { getLogger, instrument, instrumentQueryClient, tracingCookie, getDefaultSessionTracing, getClientDefaultSessionTracing, defaultLogger as logger };